export const ADD_STUDENT_REQUEST = 'ADD_STUDENT_REQUEST'
export const ADD_STUDENT_SUCCESS = 'ADD_STUDENT_SUCCESS'
export const ADD_STUDENT_FALIURE = 'ADD_STUDENT_FALIURE'
